import {
  calculateStringTimespan,
  calculateNumber,
} from '../app/components/SectionItemAudienceFilter/audienceFilterHelpers.js';
import { deleteKeysIfNull } from '../utils/objects-util.js';
import i18n from '../i18n.js';

export const marketplaceCampaignModel = data => ({
  id: data?.id || '',
  enabled: data?.enabled || false, //required
  campaign_type: data?.campaign_type || 0, //required
  campaign_types: data?.campaign_types || [data?.campaign_type || 0], //required
  business_ids: data?.business_ids || [],
  action_button_text: data?.action_button_text || '',
  start_date: data?.start_date || '', //required
  recurring_type: data?.recurring_type || 0, //required
  name: data?.name || '',
  message: data?.message || '',
  message_title: data?.message_title || '',
  audience_channel: data?.audience_channel === 0 ? null : data?.audience_channel || null,
  audience_filter: data?.audience_filter || null, // getAudienceFilterModel
  bonus_info: data?.bonus_info ? {...data.bonus_info, voucher_requires_activation: data.voucher_requires_activation} : null,
  auto_add_quantity: data?.auto_add_quantity || 0,
  max_product_discounts: data?.max_product_discounts || 0,
  allow_multiple_discounts: data?.allow_multiple_discounts || false,
  language: data.language || '',
  voucher_requires_activation: data.voucher_requires_activation || false,
  is_one_time: data.is_one_time || false
});

export const marketplaceCampaignExecutionsModel = data => ({
  campaign_type: data?.campaign_type,
  campaign_types: data?.campaign_types || [data?.campaign_type],
  name: data?.name,
  message: data?.message,
  message_title:  data?.message_title,
  bonus_info: data?.bonus_info,
  audience: data?.audience,
  action_button_text: data?.action_button_text,
  audience_channel: data?.audience_channel,
  voucher_requires_activation: data?.voucher_requires_activation,
  language: data?.language,
});

export const calcTimeSpan = (audience_filter, isString = false) => {
  const calcFunction = isString ? calculateStringTimespan : calculateNumber;
  return audience_filter?.map(filter => {
    if (filter.hasOwnProperty('timespan_value') && filter.hasOwnProperty('string_value')) {
      return {
        ...filter,
        timespan_value: calcFunction(filter.timespan_value, filter.string_value),
      };
    } else {
      return filter;
    }
  });
};

export const marketplaceCampaignServerModel = data => {
  const voucher_requires_activation = data?.bonus_info?.voucher_requires_activation || false;
  
  if(data.bonus_info) {
    delete data?.bonus_info?.voucher_requires_activation;
  }

  let start_date = data?.start_date ? data.start_date : new Date();
  if(start_date) {
    start_date = new Date(start_date);
    start_date.setSeconds(0);
    start_date.setMilliseconds(0);
  }
  return {
    ...data,
    voucher_requires_activation: voucher_requires_activation,
    business_ids: data.business_ids.map(m=> typeof m === "string" ? m : m.key),
    campaign_type: data?.campaign_types.length ? data?.campaign_types[0] : (data?.campaign_type || 0),
    campaign_types: data?.campaign_types || [data?.campaign_type || 0],
    start_date: start_date,
    audience_filter: calcTimeSpan(data.audience_filter, true),
    bonus_info: data?.audience_channel !== null ? null : data?.bonus_info
  };
};

export const marketplaceCampaignClientModel = data => {
  const audienceFilter = data?.audience_filter?.map(item => deleteKeysIfNull(item)) || null;

  return {
    ...data,
    business_ids: data?.business_ids || [],
    campaign_types: data?.campaign_types || [data?.campaign_type || 0], //required
    execution: i18n.t('settings.campaigns.EXECUTIONS'),
    audience_filter: calcTimeSpan(audienceFilter),
  };
};
